import { Option } from "@/type/Common.ts";

export const enum Role {
    /**
     * 현장 관리자
     */
    CREW = "CREW",
    /**
     * 업체 관리자
     */
    ADMIN = "ADMIN",
    /**
     * 마스터(에버온 담당자)
     */
    MASTER = "MASTER",
}

export const RoleTypeLabel: Record<Role, string> = {
    CREW: "현장 관리자",
    ADMIN: "업체 관리자",
    MASTER: "마스터(에버온 담당자)",
};

export const RoleTypeOptions: Option<Role>[] = [
    { label: RoleTypeLabel.CREW, value: Role.CREW },
    { label: RoleTypeLabel.ADMIN, value: Role.ADMIN },
    { label: RoleTypeLabel.MASTER, value: Role.MASTER },
];
